import React, { useMemo } from 'react';
import Table from '../../../atoms/table/Table';
import { IconButton } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { MRT_ColumnDef, MRT_TableInstance } from 'material-react-table';
import { useActions } from '../../../hooks/actions';
import { IExpertiseCategoryData } from '../../../store/api/types/leadership';
import { useDeleteExpertiseCategoryMutation } from '../../../store/api/leadership';

interface IProps {
  data?: Array<IExpertiseCategoryData>;
  isLoading: boolean;
  tableInstanceRef: React.RefObject<MRT_TableInstance>;
}

const ExpertiseCategoriesVLTable = ({
  data,
  isLoading,
  tableInstanceRef,
}: IProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const {
    openEditExpertiseCategoryVLModal,
    toggleSuccessSnackbar,
    toggleErrorSnackbar,
  } = useActions();

  const [deleteExpertiseCategory] = useDeleteExpertiseCategoryMutation();

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = (row: IExpertiseCategoryData) => {
    openEditExpertiseCategoryVLModal(row);
    setAnchorEl(null);
  };

  const handleDelete = (expertiseCategoryId: string) => {
    if (expertiseCategoryId) {
      deleteExpertiseCategory(expertiseCategoryId)
        .unwrap()
        .then(() =>
          toggleSuccessSnackbar({
            message: 'Expertise Category Deleted Successfully',
          })
        )
        .catch(({ data }) => toggleErrorSnackbar({ message: data.detail }));
    }
    setAnchorEl(null);
  };

  const columns = useMemo<MRT_ColumnDef<IExpertiseCategoryData>[]>(
    () => [
      {
        header: 'Category Name',
        accessorKey: 'fieldValue',
        filterFn: 'includesString',
        minSize: 255,
      },
      {
        header: 'Category ID',
        accessorKey: 'code',
        filterFn: 'includesString',
        minSize: 200,
      },
      {
        header: 'Roles w/Category',
        accessorFn: () => '',
      },
      {
        header: 'Statements w/Category',
        accessorFn: () => '',
      },
    ],
    []
  );

  return (
    <Table
      data={data ?? []}
      tableInstanceRef={tableInstanceRef}
      columns={columns as MRT_ColumnDef<object>[]}
      renderRowActions={({ cell, row }) => (
        <>
          <IconButton
            id={cell.id}
            onClick={handleOpen}
          >
            <MoreVert />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={anchorEl?.id === cell.id}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() => handleEdit(row.original as IExpertiseCategoryData)}
            >
              Edit
            </MenuItem>
            <MenuItem
              onClick={() =>
                handleDelete((row.original as IExpertiseCategoryData).id || '')
              }
            >
              Delete
            </MenuItem>
          </Menu>
        </>
      )}
      state={{ showSkeletons: isLoading }}
    />
  );
};

export default ExpertiseCategoriesVLTable;
